export default "__VITE_ASSET__3ee23e0e__"